import {
  RECURSOS_MOBILE_QUERY,
  RECURSOS_TABS,
  RECURSOS_TABS_LABEL,
  RECURSOS_TITLE,
} from "./recursos.constants";
import type { RecursosViewModel } from "./types-recursos";

/**
 * ViewModel da casca de Recursos: o conteúdo de cada aba vem da rota filha (`Outlet`).
 */
export function useRecursos(): RecursosViewModel {
  return {
    titulo: RECURSOS_TITLE,
    abas: [...RECURSOS_TABS],
    abasLabel: RECURSOS_TABS_LABEL,
    mobileQuery: RECURSOS_MOBILE_QUERY,
  };
}
